import { useTranslation } from 'react-i18next';
import { Globe } from '@phosphor-icons/react';

/**
 * Tiny EN/ES language toggle. Persists to localStorage via i18next-browser-languagedetector.
 */
export default function LanguageToggle({ className = '' }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'en').slice(0, 2);

  const toggle = () => {
    i18n.changeLanguage(current === 'en' ? 'es' : 'en');
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="language-toggle"
      aria-label="Toggle language"
      title={current === 'en' ? 'Cambiar a Español' : 'Switch to English'}
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded text-xs font-heading font-bold uppercase tracking-wide text-white/70 hover:text-white hover:bg-white/5 transition-colors ${className}`}
    >
      <Globe size={14} weight="bold" />
      {current === 'en' ? 'EN' : 'ES'}
    </button>
  );
}
